module.exports = __webpack_public_path__ + "img/zhinan.ddd44ad4.svg";